import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const extractPdf = async (formData) => {
  const { data } = await client.post("/extract-pdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const runAppraisal = async (payload) => {
  const { data } = await client.post("/appraise", payload);
  return data;
};

export const listAppraisals = async () => {
  const { data } = await client.get("/appraisals");
  return data;
};

export const getAppraisal = async (id) => {
  const { data } = await client.get(`/appraisals/${id}`);
  return data;
};

export const deleteAppraisal = async (id) => {
  const { data } = await client.delete(`/appraisals/${id}`);
  return data;
};

export const uploadPhotos = async (id, files) => {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append("files", f));
  const { data } = await client.post(`/appraisals/${id}/photos`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const deletePhoto = async (id, photoId) => {
  const { data } = await client.delete(`/appraisals/${id}/photos/${photoId}`);
  return data;
};

export const generateLetter = async (id) => {
  const { data } = await client.post(`/appraisals/${id}/letter`);
  return data;
};

export const saveLetter = async (id, text) => {
  const { data } = await client.put(`/appraisals/${id}/letter`, { text });
  return data;
};

export const fileUrl = (path) => `${API}/files/${path}`;
export const letterPdfUrl = (id) => `${API}/appraisals/${id}/letter/pdf`;
export const pdfUrl = (id) => `${API}/appraisals/${id}/pdf`;

export const getStateRules = async () => {
  const { data } = await client.get("/state-rules");
  return data;
};
